module.exports = __webpack_public_path__ + "img/Flag_of_Armenia.69727bec.svg";